module.exports = __webpack_public_path__ + "svg/sales.68daec3cada0ed7b6d359eb0b4c69ddb.svg";